import React, { Component } from 'react'
import { connect } from "react-redux"

import agent from '../agent'
// import { Field, reduxForm } from 'redux-form'

import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import Back from "../components/Back";

import ProjectSettingsForm from '../components/ProjectSettingsForm'


const Header = ({companies, project}) => (
<section id="brand-logo" className="section-brand-logo project-settings section">
  <div className="row">
  <div className="small-12 small-centered column text-center">
  	<div className="header-image-container">
  	{ 
  		companies
  		? <img className="company-logo" src={companies[0].logo_url} alt=""/>
  		: <img className="am-logo" src={AMLogo} alt=""/>
  	}
  	</div>
		<div className="post-relative">
			<Back />
	    <p className="top-title">{project ? project.name : ''} Check-In Settings</p>
    </div>
  </div>
  </div>
</section>
)

const Logout = (props) => (	
	props.appLoaded && props.clientToken
	?	<span className="logout-btn fa-stack fa-1x" onClick={props.onClickLogout} >
		  <i className="fa fa-circle fa-stack-2x icon-background"></i>
		  <i className="fa fa-sign-out fa-stack-1x"></i>
		</span>
  : ''
)

const BrandedLogo = ({project}) => (
	<section id="project-logo" className="section-project-logo section">
	  <div className="row">
	  <div className="small-12 small-centered columns text-center">
	    <p><img className="logo" src={project.cover_url} alt="" width="300"/></p>
	  </div>
	  </div>
	</section>
)


class ClientProjectSettingsContainer extends Component {
	componentWillMount() {
		const {params} = this.props.match
		this.props.onLoad(params.id)
	}

	updateSettings = (values) => {
		console.log(values)
		this.props.updateSettings(this.props.project.id, values);
	}
	render() {
		const { project, companies, updateSuccess } = this.props
		if (project) {
			return (
				<Aux>
		      <Header {...this.props} />
		      <Logout {...this.props} />
		      <BrandedLogo project={project} />
      		{
	      		<ProjectSettingsForm onSubmit={this.updateSettings} updateSuccess={updateSuccess} settings={project} />
			  	}
		    </Aux>
			)	
		}

		return (
			<Aux>
				<Header {...this.props} />
	      <section className="gray-bg section">
					<p className="text-center loading-text">Loading Settings...</p>
				</section>
	    </Aux>
		)
	}
}

// ClientProjectSettingsContainer = reduxForm({
//   // a unique name for the form
//   form: 'ProjectSettingsForm'
// })(ClientProjectSettingsContainer)


const mapStateToProps = state => ({
  ...state.client,
  ...state.common,
  ...state.auth
})
const mapDispatchToProps = (dispatch) => ({
	onLoad: id =>
		dispatch({ type: 'PROJECT_SETTINGS_PAGE', payload: agent.Client.getProjectById(id) }),
	updateSettings: (projectId, project) =>
		dispatch({ type: 'UPDATE_PROJECT_SETTINGS', payload: agent.Client.updateSettings(projectId, project) }),
	onClickLogout: () =>
		dispatch({ type: 'LOGOUT' })
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientProjectSettingsContainer)






// WEBPACK FOOTER //
// ./src/containers/ClientProjectSettingsContainer.js